import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalDocumentTemplate  {
    _originalTypeClassName = "zERP.BO.GeneralJournalDocumentTemplate";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalDocumentTemplate.translate = translateService;
}
this.Lines = [];
this.Entity = new Domain.AccountingBusinessEntity();
this.InputGroups = [];
this.Id = null;
this.Name = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Lines:any;
FiscalPeriod:any;
Entity:any;
InputGroups:any;
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.GeneralJournalDocumentTemplate.removeLines($this, $this.Lines[0]);
                }

                Domain.GeneralJournalDocumentTemplate.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalDocumentTemplate.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalDocumentTemplate.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
}
static clearLines = ($this) => { $this.Lines = null; }
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setInputGroups = ($this, items) => {
                if (items == null) items = [];
                if ($this.InputGroups == null) $this.InputGroups = [];

                const copyItems = Common.cloneObject(items);

                while ($this.InputGroups.length > 0) {
                    Domain.GeneralJournalDocumentTemplate.removeInputGroups($this, $this.InputGroups[0]);
                }

                Domain.GeneralJournalDocumentTemplate.addManyInputGroups($this, copyItems);
            }
static addManyInputGroups = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalDocumentTemplate.addInputGroups($this, items[i]);
                }
            }
static addInputGroups = ($this, item) => {
                if ($this.InputGroups == null) $this.InputGroups = [];
                if (item == null || $this.InputGroups.indexOf(item) > -1) return;
                $this.InputGroups.push(item);
}
static addRangeInputGroups = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalDocumentTemplate.addInputGroups($this, item));
            }
static removeInputGroups = ($this, item) => {
                if ($this == null || $this.InputGroups == null || $this.InputGroups.indexOf(item) === -1) return;
                var _index = $this.InputGroups.indexOf(item);
                $this.InputGroups.splice(_index, 1);
}
static clearInputGroups = ($this) => { $this.InputGroups = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}